import { formatDistanceToNow, format } from 'date-fns';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface TimestampDisplayProps {
  timestamp: string | null;
  format?: 'relative' | 'absolute' | 'both';
  className?: string;
}

export function TimestampDisplay({
  timestamp,
  format: displayFormat = 'relative',
  className,
}: TimestampDisplayProps): JSX.Element {
  if (!timestamp) {
    return <span className={className}>-</span>;
  }

  const date = new Date(timestamp);
  const absoluteTime = format(date, 'PPpp'); // e.g., "Dec 24, 2025, 10:30:00 AM"
  const relativeTime = formatDistanceToNow(date, { addSuffix: true });

  if (displayFormat === 'absolute') {
    return <span className={className}>{absoluteTime}</span>;
  }

  if (displayFormat === 'relative') {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <span className={className}>{relativeTime}</span>
          </TooltipTrigger>
          <TooltipContent>
            <p>{absoluteTime}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  // Both formats
  return (
    <span className={className}>
      {relativeTime} <span className="text-muted-foreground">({absoluteTime})</span>
    </span>
  );
}
